// Ref: https://gitlab.com/allyfinancial/ally-digital/applications/ui/ally-next/ally-next-remote-account-details/-/blob/main/src/components/Savings/SavingsToolkit/Buckets/StkBucketTiles/StkProgressBar.tsx
import React, { useEffect, useState } from 'react'
import { get } from '@ally/metronome-ui'
import styled from 'styled-components'

import {
  StyledStatusBar,
  StyledProgressBorder,
  StyledStatusBarBackground,
} from './StyledComponents'

type ProgressBarProps = {
  total: number
  actual?: number
}

const ProgressBar: React.FC<ProgressBarProps> = ({ total, actual = 0 }) => {
  const [delayedPercentage, setDelayedPercentage] = useState(0)

  let completionPercentage = Math.floor((actual / total) * 100)
  // handle negative values by converting them to 0
  completionPercentage = completionPercentage < 0 ? 0 : completionPercentage

  useEffect(() => {
    const animation = setTimeout(
      () => setDelayedPercentage(completionPercentage),
      0,
    )

    return (): void => {
      clearTimeout(animation)
    }
  }, [completionPercentage])

  return (
    <StyledProgressBorder p="none" data-testid="progress-bar">
      <StyledStatusBar
        completionPercentage={
          delayedPercentage >= 100 ? 110 : delayedPercentage
        }
      >
        <StyledStatusBarBackground
          bgColor={delayedPercentage < 100 ? '#D44980' : 'purple'}
        />
      </StyledStatusBar>
    </StyledProgressBorder>
  )
}

const ProgressBarText = styled.p`
  font-size: ${get.fontSizes('xs')};
  font-weight: ${get.fontWeights('bold')};
  line-height: 16px;
`

export { ProgressBar, ProgressBarText }
